import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_DISCOUNT_CODE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * Discount-code row. A discount can be funded by Cocopool, by the host, or split
 * proportionally before commissions (see server/api-util/lineItems.js). The
 * Cocopool funder may also emit a *second* discount-code line on the provider
 * side when the discount exceeds Cocopool's commission and cascades onto the host.
 * So we sum every discount-code line that applies to the viewer's role: the
 * bañista sees their full saving, the host sees only the part they absorb.
 */
const LineItemDiscountCodeMaybe = ({ lineItems, isProvider, intl }) => {
  const role = isProvider ? 'provider' : 'customer';
  const items = lineItems.filter(
    i =>
      i.code === LINE_ITEM_DISCOUNT_CODE &&
      !i.reversal &&
      (!i.includeFor || i.includeFor.includes(role))
  );
  if (items.length === 0) {
    return null;
  }
  const currency = items[0].lineTotal.currency;
  const total = new Money(
    items.reduce((sum, i) => sum + i.lineTotal.amount, 0),
    currency
  );
  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.discountCode" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, total)}</span>
    </div>
  );
};

LineItemDiscountCodeMaybe.defaultProps = {
  isProvider: false,
};

LineItemDiscountCodeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isProvider: bool,
  intl: intlShape.isRequired,
};

export default LineItemDiscountCodeMaybe;
